export default __webpack_public_path__ + "static/media/Freebooter's Boots of the Yellow Spring.0606b46f.jpg";